import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-signature-comp',
  templateUrl: './signature-comp.component.html',
  styleUrls: ['./signature-comp.component.scss']
})
export class SignatureCompComponent implements OnInit {
  justifyOptions:Object[]=[{}]
  usageOptions:Object[]=[{}]
  msg:string=""
  pmsg:string=""
  constructor() { }
  value:string="1"
  value1:string=""
  ngOnInit(): void {
    this.justifyOptions = [
      {icon: 'pi pi-align-left', justify: 'Left',value:'1'},
      {icon: 'pi pi-align-right', justify: 'Right',value:'2'},
      {icon: 'pi pi-align-justify', justify: 'Justify',value:'3'}
    ];
    this.usageOptions = [
      {name: 'On every message', value:'1'},
      {name: 'On first reply', value:'2'},
      {name: 'Add manually', value:'3'}
    ];
  }
  paddSignature(event:string):void{
    this.pmsg=this.pmsg + event
  }
  eaddSignature(event:string):void{
    this.msg=this.msg + event
  }
}
